import { renderToStaticMarkup } from 'react-dom/server';
import { createElement } from 'react';
import {
    YoungBoyIllustration,
    YoungGirlIllustration,
    MiddleAgeManIllustration,
    MiddleAgeWomanIllustration,
    AgedWomanIllustration,
    ManEarlyAssistantIllustration,
    WomanEarlyAssistantIllustration,
    ManLateAssistantIllustration,
    WomanLateAssistantIllustration,
} from '@/features/client-onboarding';
import type { PdfIllustrations } from '@/features/pdf-report/types';

const SIZE = 260;
const ILLUSTRATION_COLOR = '#111827';

function svgToPngDataUri(
    Component: React.ComponentType<React.SVGProps<SVGSVGElement>>,
    fillColor: string,
): Promise<string> {
    const svgMarkup = renderToStaticMarkup(
        createElement(Component, { width: SIZE, height: SIZE, style: { color: fillColor } }),
    );
    const coloredMarkup = svgMarkup.replace(/currentColor/g, fillColor);
    const blob = new Blob([coloredMarkup], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = SIZE * 2;
            canvas.height = SIZE * 2;
            const ctx = canvas.getContext('2d')!;
            ctx.drawImage(img, 0, 0, SIZE * 2, SIZE * 2);
            URL.revokeObjectURL(url);
            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = reject;
        img.src = url;
    });
}

export async function renderIllustrationsToPng(): Promise<PdfIllustrations> {
    const [youngBoy, youngGirl, middleAgeMan, middleAgeWoman, agedWoman, manEarlyAssistant, womanEarlyAssistant, manLateAssistant, womanLateAssistant] =
        await Promise.all([
            svgToPngDataUri(YoungBoyIllustration, ILLUSTRATION_COLOR),
            svgToPngDataUri(YoungGirlIllustration, ILLUSTRATION_COLOR),
            svgToPngDataUri(MiddleAgeManIllustration, ILLUSTRATION_COLOR),
            svgToPngDataUri(MiddleAgeWomanIllustration, ILLUSTRATION_COLOR),
            svgToPngDataUri(AgedWomanIllustration, ILLUSTRATION_COLOR),
            svgToPngDataUri(ManEarlyAssistantIllustration, ILLUSTRATION_COLOR),
            svgToPngDataUri(WomanEarlyAssistantIllustration, ILLUSTRATION_COLOR),
            svgToPngDataUri(ManLateAssistantIllustration, ILLUSTRATION_COLOR),
            svgToPngDataUri(WomanLateAssistantIllustration, ILLUSTRATION_COLOR),
        ]);

    return { youngBoy, youngGirl, middleAgeMan, middleAgeWoman, agedWoman, manEarlyAssistant, womanEarlyAssistant, manLateAssistant, womanLateAssistant };
}
